(function ($) {
    function timeToKey(t) {
        return 't' + Math.floor(t * 10);
    }
    function Player($el, seekTime) {
        var that = this;
        var j = 0;
        while (!$el[0].id) {
            var id = 'id' + ($.now() - j++);
            if (!document.getElementById(id)) {
                $el[0].id = id;
            }
        }
        this.timeListeners = [];
        this.playListeners = [];
        this.currentTime = 0;
        this._seeked = false;
        this._seekTime = seekTime;
        this.$el = $el;
        this._videoChecked = false;
        this.isFullscreenControllable = false;
        $el.css({ overflow: 'hidden' });
        if ($el.attr('data-wistia-key')) {
            if (!window.Wistia) {
                alert('Wistia Player did not load, aborting video setup');
                return;
            }
            this._wistiaEmbed = Wistia.embed($el.attr('data-wistia-key'), {
                version: 'v1',
                videoWidth: $el.width(),
                videoHeight: $el.height(),
                playerColor: $el.attr('data-wistia-player-color') || '5b905b',
                platformPreference: 'flash',
                fullscreenButton: false,
                doNotTrack: false,
                container: $el[0].id,
            });
            this._wistiaEmbed.bind('timechange', function (t) {
                if (!that._videoChecked) {
                    that.$vid = $('video', $el);
                    if (that.$vid.size() > 0) {
                        that.isFullscreenControllable = Boolean(that.$vid[0].webkitExitFullscreen) && Boolean(that.$vid[0].webkitEnterFullscreen);
                        that.$vid.css({ position: 'absolute', top: 0, left: 0, zIndex: 0 });
                    }
                    that._videoChecked = true;
                }
                that._timeChanged(t);
            });
            this._wistiaEmbed.bind('play', function () {
                that._playEvent();
            });
            $.extend(this, WistiaPlayer);
        }
        else {
            this._milliseconds = 0;
            this._updateInterval = null;
            $el.addClass('mock');
            $el.append('<a class="mock-play" href="#">Play</a>').append('<a class="mock-pause" href="#">Pause</a>').append('<a class="mock-plus-1" href="#">+1:00</a>').append('<div class="time"></div>');
            this._$timeReadout = $el.find('div.time');
            $el.find('a.mock-play').on('click', function (ev) {
                ev.preventDefault();
                that.play();
            });
            $el.find('a.mock-pause').on('click', function (ev) {
                ev.preventDefault();
                that.pause();
            });
            $el.find('a.mock-plus-1').on('click', function (ev) {
                ev.preventDefault();
                that._milliseconds += 60000;
            });
            // FIXME: these elements should not be in the JS
            $el.find('a').css({ position: 'absolute', bottom: '10px', left: '10px', color: 'white' });
            $el.find('div.time').css({
                'position': 'absolute', 'bottom': '50px', 'left': '10px',
                'color': 'white', 'font-size': '20px'
            });
            $el.find('a.mock-pause').css({ 'left': '90px' });
            $el.find('a.mock-plus-1').css({ 'left': '170px' });
            $.extend(this, MockPlayer);
        }
    }
    $.extend(Player.prototype, {
        play: $.noop,
        pause: $.noop,
        seek: $.noop,
        duration: function () {
            return 0.0;
        },
        time: function () {
            return this.currentTime;
        },
        showOverlay: function ($overlay) {
            if (this.$overlay) {
                this.removeOverlay();
            }
            this.$overlay = $overlay;
            $('object, video', this.$el).css('top', -6000);
            // create shade
            var $shade = $('<div class="shade"></div>');
            this.$el.append($shade);
            $shade.css('opacity', 0.8);
            // create an overlay over shade to contain content
            this.$el.append($overlay);
            $overlay.addClass('overlay');
        },
        removeOverlay: function () {
            $('.shade', this.$el).remove();
            this.$overlay.remove();
            this.$overlay = null;
            $('object, video', this.$el).css('top', 0);
        },
        onTime: function (f) {
            this.timeListeners.push(f);
        },
        enterFullscreen: function () {
            if (!this.isFullscreenControllable) {
                return;
            }
            this.$vid[0].webkitEnterFullscreen();
        },
        exitFullscreen: function () {
            if (!this.isFullscreenControllable) {
                return;
            }
            this.$vid[0].webkitExitFullscreen();
        },
        getIsFullscreen: function () {
            if (!this.isFullscreenControllable) {
                return false;
            }
            return this.$vid[0].webkitDisplayingFullscreen;
        },
        _timeChanged: function (t) {
            if (!this._seeked) {
                this._seeked = true;
                if (this._seekTime) {
                    this.seek(this._seekTime);
                }
            }
            this.currentTime = t;
            $.each(this.timeListeners, function () {
                this(t);
            });
        },
        _playEvent: function () {
            $.each(this.playListeners, function () {
                this();
            });
        },
        offTime: function (f) {
            this.timeListeners = $.grep(this.timeListeners, function (listener) {
                return listener !== f;
            });
        },
        onPlay: function (f) {
            this.playListeners.push(f);
        },
        offPlay: function (f) {
            this.playListeners = $.grep(this.playListeners, function (listener) {
                return listener !== f;
            });
        },
    });
    var WistiaPlayer = {
        play: function () {
            this._wistiaEmbed.play();
        },
        pause: function () {
            this._wistiaEmbed.pause();
        },
        seek: function (t) {
            if (typeof t !== 'undefined') {
                this._wistiaEmbed.time(t);
            }
        },
        time: function () {
            return this._wistiaEmbed.time();
        },
        duration: function () {
            return this._wistiaEmbed.duration();
        },
    };
    var MockPlayer = {
        play: function () {
            if (this._updateInterval) {
                return;
            }
            this._playEvent();
            var player = this;
            if (!this._seeked) {
                this._seeked = true;
                this._milliseconds = Math.floor(this._seekTime * 1000);
                this.currentTime = this._milliseconds / 1000;
            }
            this._updateInterval = setInterval(function () {
                player._milliseconds += 100;
                var sec = player._milliseconds / 1000;
                player.currentTime = sec;
                player._updateReadout(sec);
                player._timeChanged(sec);
            }, 100);
        },
        _updateReadout: function (s) {
            var m = Math.floor(s / 60);
            s = s % 60;
            var time;
            if (s < 10) {
                time = '' + m + ':0' + s;
            }
            else {
                time = '' + m + ':' + s;
            }
            if (time.length > 7) {
                time = time.substring(0, 7);
            }
            this._$timeReadout.text(time);
        },
        pause: function () {
            if (!this._updateInterval) {
                return;
            }
            clearInterval(this._updateInterval);
            this._updateInterval = null;
        },
        seek: function (t) {
            this._milliseconds = Math.round(t * 1000);
            this.currentTime = t;
            this._updateReadout(t);
        },
        duration: function () {
            // Mock videos are always 2 minutes long
            return 60.0;
        },
    };
    $.fn.videoSchedule = function (command, arg1, arg2, arg3) {
        var scalarReturn;
        var player;
        var internalSchedule;
        var $queryReturn = this.each(function () {
            var $el = $(this);
            if (command === 'player') {
                scalarReturn = $el.data('hshsPlayer') || null;
            }
            else if (command === 'add') {
                player = $el.data('hshsPlayer');
                internalSchedule = $el.data('hshsSchedule');
                if (!(player && internalSchedule)) {
                    return;
                }
                var timeIndex = parseFloat(arg1);
                var callBack = arg2;
                var repeatOk = arg3;
                var entry = {
                    time: timeIndex,
                    callBack: callBack,
                    activated: false,
                    lastFired: 0,
                    repeatOk: repeatOk,
                };
                for (var offset = 0.0; offset < 1.5; offset += 0.1) {
                    var key = timeToKey(timeIndex + offset);
                    if (!internalSchedule[key]) {
                        internalSchedule[key] = [];
                    }
                    internalSchedule[key].push(entry);
                }
            }
            else {
                if ($el.data('hshsPlayer')) {
                    return;
                }
                var seekTo = parseFloat($el.attr('data-seek-to') || '0.0');
                internalSchedule = {};
                player = new Player($el, seekTo);
                $el.data('hshsPlayer', player).data('hshsSchedule', internalSchedule);
                var playScheduleAt = function (t) {
                    var k = timeToKey(t);
                    var entries = internalSchedule[k];
                    if (!entries) {
                        return;
                    }
                    var now = $.now();
                    $.each(entries, function (id, entry) {
                        if (entry.activated && !entry.repeatOk) {
                            return;
                        }
                        // Note that this doesn't allow the entry to repeat
                        // within 12 seconds This is specifically written
                        // to exceed the backup timer of 10 seconds
                        if ((now - entry.lastFired) < 12000) {
                            return;
                        }
                        entry.lastFired = now;
                        entry.activated = true;
                        var secondsOff = t - entry.time;
                        if (secondsOff > 0.5) {
                            player.seek(entry.time);
                        }
                        entry.callBack(player, entry.time);
                    });
                };
                player.onTime(playScheduleAt);
                // once the video starts playing, if we're waiting to seek,
                // seek then if a schedule object was passed, setup each entry now
                if (command) {
                    var schedule = command;
                    $.each(schedule, function (timeIndex, callBack) {
                        $el.videoSchedule('add', timeIndex, callBack);
                    });
                }
                // setup a backup timer to make sure events fire. Every 10 seconds it will try and fire any
                // scheduled events in the last 10 seconds
                var lastT = 0;
                setInterval(function () {
                    var currentTime = player.time();
                    if (Math.abs(currentTime - lastT) < 10) {
                        return;
                    }
                    lastT = currentTime;
                    for (var t = currentTime - 10.0; t <= currentTime; t += 0.5) {
                        playScheduleAt(t);
                    }
                }, 10000);
            }
        });
        if (typeof scalarReturn !== 'undefined') {
            return scalarReturn;
        }
        else {
            return $queryReturn;
        }
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./courses/static/courses/js-src/hshs-video.ts
// module id = 9
// module chunks = 0